import {Component, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-account-faqs',
  templateUrl: './account-faqs.component.html',
  styleUrls: ['./account-faqs.component.scss']
})
export class AccountFaqsComponent implements OnInit {

  public url: string;
  public loaded: boolean = false;

  private readonly faqsBaseUrl: string = 'https://www.zumex.com/wp-content/uploads/2023/01/zumexconnect_faq_';
  private readonly pdfExt: string = '.pdf';

  private language: string;


  constructor(private readonly i18n: TranslocoService) {
  }

  ngOnInit(): void {
    this.language = this.i18n.getActiveLang();
    this.url = this.faqsBaseUrl + this.language + this.pdfExt;
    this.loaded = true;
  }

}
